import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/junli/work/fun/hooks/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { useTimeInterval, useToggle } from "../../index";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "usetimeinterval"
    }}>{`useTimeInterval`}</h1>
    <p>{`timeInterval hooks`}</p>
    <p>{`参考 `}<a parentName="p" {...{
        "href": "https://overreacted.io/making-setinterval-declarative-with-react-hooks/"
      }}>{`Making setInterval Declarative with React Hooks`}</a></p>
    <hr />
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`useTimeInterval(
  callback: Function,
  delay?: number
);
`}</code></pre>
    <hr />
    <h2 {...{
      "id": "demo"
    }}>{`DEMO`}</h2>
    <Playground __position={2} __code={'() => {\n  const [counter, setCounter] = React.useState(0)\n  const [run, toggleRun] = useToggle()\n  const delay = 1000\n  useTimeInterval(\n    () => {\n      setCounter(pre => pre + 1)\n    },\n    run ? delay : null,\n  )\n  return (\n    <div>\n      <h4>count: {counter}</h4>\n      <button onClick={toggleRun}>{run ? \'stop\' : \'start\'}</button>\n    </div>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      useTimeInterval,
      useToggle,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const [counter, setCounter] = React.useState(0);
        const [run, toggleRun] = useToggle();
        const delay = 1000;
        useTimeInterval(() => {
          setCounter(pre => pre + 1);
        }, run ? delay : null);
        return <div>
        <h4>count: {counter}</h4>
        <button onClick={toggleRun}>{run ? 'stop' : 'start'}</button>
      </div>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      